import React from "react";
import { Datacenter, datadogLogs } from "@datadog/browser-logs";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import { hydrate } from "react-dom";
import { PublicListingsAppContainer } from "./containers/PublicListingsAppContainer/PublicListingsAppContainer";
import * as PublicListingsView from "../../domain/models/PublicListingsView";

declare const window: Window & { __LISTINGS__: PublicListingsView.T };

const render = (): void => {
    datadogLogs.init({
        clientToken: (env.REACT_APP_DATADOG_CLIENT_TOKEN || ""),
        forwardErrorsToLogs: true,
        datacenter: Datacenter.EU,
        sampleRate: 100,
    });

    hydrate(
        <PublicListingsAppContainer view={window.__LISTINGS__} />,
        document.getElementById("app"),
    );
};

render();
